enum ErrorType {
  CLIENT = 'CLIENT',
  SERVER = 'SERVER',
  BLOCKED_BY_CLIENT = 'BLOCKED_BY_CLIENT',
  OTHER = 'OTHER',
}

export const checkApiBlocked = async (
  apiUrl: string,
): Promise<{
  blocked: boolean
  errorType: ErrorType | null
}> => {
  try {
    const response = await fetch(apiUrl)
    if (!response.ok) {
      if (response.status >= 400 && response.status < 500) {
        throw new Error('Client')
      } else if (response.status >= 500) {
        throw new Error('Server')
      } else {
        throw new Error('Network response was not ok')
      }
    }
    return { blocked: false, errorType: null }
  } catch (error) {
    if ((error as Error).message === 'Client') {
      return { blocked: false, errorType: ErrorType.CLIENT }
    } else if ((error as Error).message === 'Server') {
      return { blocked: false, errorType: ErrorType.SERVER }
    } else if (
      (error as Error).message.includes('Failed to fetch') || // Chrome
      (error as Error).message.includes('Load failed') || // Safari
      (error as Error).message.includes('NetworkError when attempting to fetch resource.') // Firefox
    ) {
      return { blocked: true, errorType: ErrorType.BLOCKED_BY_CLIENT }
    } else {
      return { blocked: true, errorType: ErrorType.OTHER }
    }
  }
}
